import mitt from 'mitt';
export const emitter = mitt();

/*
* 这里是正则验证的文件
* */
//手机号码验证
export function iphone (val) {
  let reg = /^(13[0-9][0-9]{8}|14[0-9][0-9]{8}|15[0-9][0-9]{8}|16[0-9][0-9]{8}|17[0-9][0-9]{8}|18[0-9][0-9]{8}|19[0-9][0-9]{8})$/;
  return reg.test(val);
}


export const isObject = (val) => {
  // 判断传入的参数的类型是否为对象，并且使用Object.prototype.toString.call方法判断是否为Object对象
  return typeof val === 'object' && Object.prototype.toString.call(val) === '[object Object]'
}

// 跳转(区分打开方式)
export const goAppId = {
  1: 'pageId',
  2: 'pageId',
  3: 'pageId',
  4: 'pageId',
  5: 'pageId',
  6: 'dataId',
  7: 'dataId',
  8: 'funId',
  9: 'funId',
  10: 'funId',
  11: 'addId',
  12: 'addId',
  13: 'pageId',
  14: 'dataId',
  15: 'pageId',
  16: 'dataId',
  17: 'pageId',
  18: 'dataId'
}


// 获取随机数
export const getRandom = (min, max) => {
  const num = Math.floor(Math.random() * (max - min + 1)) + min
  return num
}